import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormContext from "../context/formContext";
import { useToast } from "@chakra-ui/react";
import BackLogout from "../component/backLogout";
import Loader from "../component/loader";

function FormPage1() {
  const toast = useToast();
  const navigate = useNavigate();
  const [ageinput, setAgeIput] = useState();
  
  const [fp1loader, setFP1loader] = useState(false);
  const context = useContext(FormContext);
  const { loginObj, setLoginObj } = context;


  // new

  //const [textselected,setTextselected] = useState("");

  const handleCountAge = (e) => {
    const calculate_age = (dob1) => {
      var today = new Date();
      var birthDate = new Date(dob1);
      var age_now = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age_now--;
      }
      return age_now;
    };
    setAgeIput(calculate_age(e.target.value));
  };

  const handleSaveFormPage1 = () => {
    loginObj["student_id"] = localStorage.getItem("studentId");
    loginObj["age"] = ageinput;
    loginObj["pmgApplied"] = "U.G";
    loginObj["db_name"] = "erp_eshiksa";
    loginObj["email"] = localStorage.getItem('email')

    if (loginObj.subjectsName === "PCBE") {
      if (loginObj.TestSelected) {
        loginObj.TestSelected = "B.F. Sc., B. Tech. (Biotechnology), B. Tech. (Food Science & Technology)";
      } else {
        loginObj["TestSelected"] = "B.F. Sc., B. Tech. (Biotechnology), B. Tech. (Food Science & Technology)";
      }
    } else if (loginObj.subjectsName === "PCME") {
      if (loginObj.TestSelected) {
        loginObj.TestSelected = "B. Tech. (Dairy Technology), B. Tech. (Biotechnology), B. Tech. (Food Science & Technology)";
      } else {
        loginObj["TestSelected"] = "B. Tech. (Dairy Technology), B. Tech. (Biotechnology), B. Tech. (Food Science & Technology)";
      }
    } else if (loginObj.subjectsName === "PCBME") {
      if (loginObj.TestSelected) {
        loginObj.TestSelected = "B.F. Sc. B. Tech. (Dairy Technology), B. Tech. (Biotechnology), B. Tech. (Food Science & Technology)";
      } else {
        loginObj["TestSelected"] = "B.F. Sc. B. Tech. (Dairy Technology), B. Tech. (Biotechnology), B. Tech. (Food Science & Technology)";
      }
    }
    
    /*if (loginObj.subjectsName === "PCBE") {
      if (loginObj.TestSelected) {
        loginObj.TestSelected = loginObj.TestSelected;
      } else {
        loginObj["TestSelected"] = loginObj.TestSelected;
      }
    } else if (loginObj.subjectsName === "PCME") {
      if (loginObj.TestSelected) {
        loginObj.TestSelected = loginObj.TestSelected;
      } else {
        loginObj["TestSelected"] = loginObj.TestSelected;
      }
    } else if (loginObj.subjectsName === "PCBME") {
      if (loginObj.TestSelected) {
        loginObj.TestSelected = loginObj.TestSelected;
      } else {
        loginObj["TestSelected"] = loginObj.TestSelected;
      }
    }*/

    loginObj["sessionYear"] = "2025-26";
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ci_session=gliuijh4lm0h2rlafbvtgo6r8vj6f9if");
    myHeaders.append("auth_token", localStorage.getItem('token'));
    var raw = JSON.stringify(loginObj);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch("https://erpapi.eshiksa.net/Gadvasu/SaveData.php", requestOptions)
      .then((response) => response.text())
      .then((result) => {
        var responseObjFS = JSON.parse(result);
        if (responseObjFS.success === 1) {
          setFP1loader(false);
          toast({
            title: "Alert",
            description: responseObjFS.msg,
            status: "success",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
          navigate("/FormPage2");
        }
      })
      .catch((error) => console.log("error", error));
  };

  const handleSubmitPage1 = (e) => {
    e.preventDefault();
    setFP1loader(true);
    handleSaveFormPage1();
  };

  const handleaadharl = (e) => {
    let input = e.target.value;
  
   

    // Define the regular expression pattern
    const pattern = /^[0-9]*$/;

    // Check if the input matches the pattern
    if (pattern.test(input)) {
     
      e.target.value = input.slice(0, 12);
    }
    else{
      e.target.value = null;
    }
  };

  useEffect(() => {
    // Prompt confirmation when reload page is triggered
    window.onbeforeunload = () => {
      return "";
    };
    window.scrollTo(0, 0);

    // Unmount the window.onbeforeunload event
    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ci_session=ks1r6e3hp01h9psp1ufu608e45l56ri4");
    myHeaders.append("auth_token", localStorage.getItem('token'));
    var raw = JSON.stringify({
      // Branch_id: "1729",
      Branch_id: "2244",
      student_id: localStorage.getItem("studentId"),
      email: localStorage.getItem("email"),
      db_name: "erp_eshiksa",
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://erpapi.eshiksa.net/Gadvasu/getStudentData.php",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        var resultObj = JSON.parse(result);

        if (resultObj.success === 1) {
          setLoginObj(resultObj.form_data);
        }else{
          toast({
            title: 'Alert',
            description: resultObj.msg,
            status: 'error',
            duration: 1000,
            isClosable: true,
            position: 'top',
          })
        }
      })
      .catch((error) => console.log("error", error));
    // eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      <div className="container-fluid" style={{width: '95%'}}>
        <div>
        <button className='btn btn-sm my-2 ' style={{border: '1px solid #a6191f', color: '#a6191f'}}> <i className="fa-solid fa-user mx-2"> </i>{loginObj.name}</button>

          <BackLogout />
        </div>

        <form onSubmit={(e) => handleSubmitPage1(e)}>
          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light">Programme Information</h6>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Programme Applied for *</label>
                <input
                  name="pmgApplied"
                  className="form-control"
                  value={"U.G"}
                  readOnly
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Undergraduate-Programme *</label>
                {loginObj.subjectsName === "PCBE" && (
                  <>
                    <input
                      name="TestSelected"
                      className="form-control"
                      value={"B.F. Sc., B. Tech. (Biotechnology), B. Tech. (Food Science & Technology)"}
                      readOnly
                    />
                   {/* <select
                  name="TestSelected"
                  className="form-select"
                  required
                  value={loginObj.TestSelected}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="B.F.Sc.,B.Tech.(Biotechnology)">B.F.Sc.,B.Tech.(Biotechnology)</option>
                  <option value="B. Tech. (Food Science & Technology)">B. Tech. (Food Science & Technology)</option>
                </select> */}
                  </>
                )}
                {loginObj.subjectsName === "PCME" && (
                  <>
                    <input
                      name="TestSelected"
                      className="form-control"
                      value={
                        "B. Tech. (Dairy Technology), B. Tech. (Biotechnology), B. Tech. (Food Science & Technology)"
                      }
                      readOnly
                    />
                      {/* <select
                  name="TestSelected"
                  className="form-select"
                  required
                  value={loginObj.TestSelected}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="B.F.Sc.,B.Tech.(Biotechnology)">B.F.Sc.,B.Tech.(Biotechnology)</option>
                  <option value="B. Tech. (Food Science & Technology)">B. Tech. (Food Science & Technology)</option>
                </select>*/}
                  </>
                )}
                {loginObj.subjectsName === "PCBME" && (
                  <>
                    <input
                      name="TestSelected"
                      className="form-control"
                      value={
                        "B.F. Sc. B. Tech. (Dairy Technology), B. Tech. (Biotechnology), B. Tech. (Food Science & Technology)"
                      }
                      readOnly
                    /> 

                {/*<select
                  name="TestSelected"
                  className="form-select"
                  required
                  value={loginObj.TestSelected}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="B.F.Sc.,B.Tech.(Biotechnology)">B.F.Sc.,B.Tech.(Biotechnology)</option>
                  <option value="B. Tech. (Food Science & Technology)">B. Tech. (Food Science & Technology)</option>
                </select>*/}
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="row border border-3 rounded-3 my-3">
            <div className="p-0">
              <div className="w-100 p-1 pt-2 px-3 form_input_header">
                <h6 className="text-light">Personal Information</h6>
              </div>
            </div>
            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Name of the Applicant *</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Name of the Applicant"
                  value={loginObj.name}
                  required
                  readOnly
                  // onChange={(e) =>
                  //   setLoginObj({
                  //     ...loginObj,
                  //     [e.target.name]: e.target.value,
                  //   })
                  // }
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Email*</label>
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder="example@some.com"
                  required
                  value={loginObj.email}
                  readOnly
                  // onChange={(e) =>
                  //   setLoginObj({
                  //     ...loginObj,
                  //     [e.target.name]: e.target.value,
                  //   })
                  // }
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Mobile Number*</label>
                <input
                  type="number"
                  className="form-control number-input"
                  name="mobile_no"
                  placeholder="Mobile Number"
                  required
                  value={loginObj.mobile_no}
                  readOnly
                  // onChange={(e) =>
                  //   setLoginObj({
                  //     ...loginObj,
                  //     [e.target.name]: e.target.value,
                  //   })
                  // }
                />
              </div>
            </div>

            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Gender *</label>
                <select
                  name="gender"
                  className="form-select"
                  required
                  value={loginObj.gender}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Date of Birth*</label>
                <input
                  type="date"
                  className="form-control"
                  name="DOB"
                  value={loginObj.DOB}
                  placeholder="example@some.com"
                  required
                  onChange={(e) => {
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    });
                    handleCountAge(e);
                  }}
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Age</label>
                <input
                  type="number"
                  className="form-control number-input"
                  readOnly
                  name="age"
                  placeholder="Your Age"
                  value={ageinput || loginObj.age}
                  required
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Father's Name*</label>
                <input
                  type="text"
                  className="form-control"
                  name="father_name"
                  placeholder="Father's Name"
                  required
                  value={loginObj.father_name}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Mother's Name*</label>
                <input
                  type="text"
                  className="form-control"
                  name="mother_name"
                  placeholder="Mother's Name"
                  required
                  value={loginObj.mother_name}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Aadhaar No</label>
                <input
                  type="number"
                  className="form-control number-input"
                  name="aadharNo"
                  placeholder="xxxxxxxxxxxx"
                  value={loginObj.aadharNo}
                  onKeyUp={handleaadharl}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                />
              </div>
            </div>

            <div className="row p-3">
              <div className="col-sm-12 col-lg-4">
                <label className="form-label">Religion *</label>
                <select
                  name="religion"
                  className="form-select"
                  required
                  value={loginObj.religion}
                  onChange={(e) =>
                    setLoginObj({
                      ...loginObj,
                      [e.target.name]: e.target.value,
                    })
                  }
                >
                  <option value="" disabled selected>
                    Select
                  </option>
                  <option value="Hindu">Hindu</option>
                  <option value="Muslim">Muslim</option>
                  <option value="Sikh">Sikh</option>
                  <option value="Christian">Christian</option>
                  <option value="other">Other</option>
                </select>
              </div>
              

              {loginObj.resident === "Yes" && (
                <>
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">
                      Whether belongs to Sports Person Category ?*
                    </label>
                    <select
                      name="isSports"
                      className="form-select"
                      required
                      value={loginObj.isSports}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled selected>
                        Select
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  {loginObj.isSports === "Yes" && (
                    <div className="col-sm-12 col-lg-4">
                      <label className="form-label">
                        Game Played in last qualified exam*
                      </label>
                      <select
                        name="sportsCategory"
                        className="form-select"
                        required
                        value={loginObj.sportsCategory}
                        onChange={(e) =>
                          setLoginObj({
                            ...loginObj,
                            [e.target.name]: e.target.value,
                          })
                        }
                      >
                        <option value="" disabled selected>
                          Select
                        </option>
                        <option value="Athletics">Athletics</option>
                        <option value="Badminton">Badminton</option>
                        <option value="Basketball">Basketball</option>
                        <option value="Cricket">Cricket</option>
                        <option value="Cycling">Cycling</option>
                        <option value="Equestrian">Equestrian</option>
                        <option value="Football">Football</option>
                        <option value="Handball">Handball</option>
                        <option value="Hockey">Hockey</option>
                        <option value="Kabaddi">Kabaddi</option>
                        <option value="Lawn Tennis">Lawn Tennis</option>
                        <option value="Shooting">Shooting</option>
                        <option value="Swimming">Swimming</option>
                        <option value="Table Tennis">Table Tennis</option>
                        <option value="Volley Ball">Volley Ball</option>
                        <option value="Weigh Lifting">Weigh Lifting</option>
                        <option value=" Roller Skating"> Roller Skating</option>
                      </select>
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="row p-3">
            <div className="col-sm-12 col-lg-4">
                    <label className="form-label">
                    Whether belong to Kashmiri Migrant Category ?*
                    </label>
                    <select
                      name="whetherfromKM"
                      className="form-select"
                      required
                      value={loginObj.whetherfromKM}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled selected>
                        Select
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                
            </div>
            {loginObj.resident === "Yes" && (
              <>
                <div className="col-sm-12 col-lg-4">
                    <label className="form-label">
                      Whether belongs to Disabled Person Category?*
                      &nbsp;&nbsp;&nbsp;
                    </label>
                    <select
                      name="whetherDisabled"
                      className="form-select"
                      value={loginObj.whetherDisabled}
                      required
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled selected>
                        Select
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                <div className="row p-3">
                  {/* <div className="col-sm-12 col-lg-4">
                    <label className="form-label">
                      Whether belongs to Disabled Person Category?*
                      &nbsp;&nbsp;&nbsp;
                    </label>
                    <select
                      name="whetherDisabled"
                      className="form-select"
                      value={loginObj.whetherDisabled}
                      required
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled selected>
                        Select
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div> */}
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">
                      Whether belongs to Freedom Fighter Category?*
                    </label>
                    <select
                      name="whetherFreedomF"
                      className="form-select"
                      required
                      value={loginObj.whetherFreedomF}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled selected>
                        Select
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">
                      Whether belongs to Armed Force Category?*
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </label>
                    <select
                      name="whetherArmedF"
                      className="form-select"
                      required
                      value={loginObj.whetherArmedF}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled selected>
                        Select
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>

                <div className="row p-3">
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">
                      Whether belongs to Terrorist Affected Category?*
                    </label>
                    <select
                      name="whetherTerrorAffctd"
                      className="form-select"
                      required
                      value={loginObj.whetherTerrorAffctd}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled selected>
                        Select
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">
                      Whether belongs to Border Area Category?* &nbsp; &nbsp;
                      &nbsp; &nbsp;
                    </label>
                    <select
                      name="whetherBorderArea"
                      className="form-select"
                      required
                      value={loginObj.whetherBorderArea}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled selected>
                        Select
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div className="col-sm-12 col-lg-4">
                    <label className="form-label">
                      Whether belongs to Rural Area Category?* &nbsp; &nbsp;
                      &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    </label>
                    <select
                      name="whetherRuralArea"
                      className="form-select"
                      required
                      value={loginObj.whetherRuralArea}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled selected>
                        Select
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>


                  <div className="col-sm-12 col-lg-4 py-3">
                    <label className="form-label">
                    Whether belong to the Backward Area Category?* &nbsp; &nbsp;
                      
                    </label>
                    <select
                      name="whetherBackwardAreaCategory"
                      className="form-select"
                      required
                      value={loginObj.whetherBackwardAreaCategory}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled selected>
                        Select
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>

                  {/* <div className="col-sm-12 col-lg-4 py-3">
                    <label className="form-label">
                    Whether belongs to the Orphan Child Category?* &nbsp; &nbsp;
                    </label>
                    <select
                      name="whetherChildCategory"
                      className="form-select"
                      required
                      value={loginObj.whetherChildCategory}
                      onChange={(e) =>
                        setLoginObj({
                          ...loginObj,
                          [e.target.name]: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled selected>
                        Select
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div> */}


                



                  
                </div>
              </>
            )}
          </div>

          <div className="row justify-content-around my-5">
            <button
            type="submit"
            className="btn btn-primary w-25"
            disabled={fp1loader}
          >
            Submit
            {
              fp1loader && <Loader/>
            }
            
          </button>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
}

export default FormPage1;
